<template>
  <div>
    <v-row v-if="componenteEvento.agregar_submodulo">
      <v-col class="d-flex justify-end">
        <TableButtonComp normalButton text-button="Crear nivel" iconBut="fas fa-plus" @click="addItem" />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="pl-5 pr-5" v-if="mostrarMensaje">
        <v-card outlined>
          <v-card-text style="min-height:200px" class="text-center d-flex align-center justify-center">
            Aún no has agregado ningún nivel al colegio
          </v-card-text>
        </v-card>

      </v-col>

      <v-col cols="12" md="6" class="d-flex justify-center" v-for="nivel of NivelesMantenimiento" :key="nivel.id">
        <v-card :color="nivel.color" width="240" dark elevation="7">
          <v-list-item three-line>
            <v-list-item-content class="py-0">
              <span class="mb-1">
                <h3>{{ nivel.desc_nivel }}</h3>
              </span>
            </v-list-item-content>
          </v-list-item>

          <v-card-actions class="white">
            <v-spacer />
            <TableButtonComp editButton v-if="componenteEvento.editar_submodulo" @click="editItem(nivel)"
              tooltipText="Editar nivel" />

            <TableButtonComp deleteButton v-if="componenteEvento.borrar_submodulo" @click="deleteConfirm(nivel)"
              tooltipText="Eliminar nivel" class="mx-2" />
            <!-- <v-row>
              <v-col cols="8">
                <TableButtonComp v-if="componenteEvento.visualizar_submodulo" text-button="Ver Grados"
                  iconBut="fas fa-eye" @click="getAllGradosNivel(nivel)" />
              </v-col>
            </v-row> -->


          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- modal agregar editar nivel -->
    <!-- modal edit and save Nivel-->
    <v-form ref="formDatos" lazy-validation>
      <ComunDialogComp :title="formTitle" :evento="evento" v-model="dialog" maxWidth="450" @close-modal="closeEdit">
        <template v-slot:body>
          <v-row dense>
            <v-col cols="12">
              <AutocompleteComp textLabel="Nivel según Minedu" :items="NivelesMinedu" item-text="desc_nivel"
                item-value="id" v-model="editedItem.id_nivel_clickone" :rules="validationRules.validateNivel"
                :isDisable="bloquearCampo" @change="addNivelMinedu(editedItem.id_nivel_clickone)" />
            </v-col>

            <v-col cols="12">
              <textfieldComp v-model="editedItem.desc_nivel" textLabel="Nombre del nivel"
                :rules="validationRules.validateCampo" />
            </v-col>

            <v-col cols="12">
              <textfieldComp :textLabel="$t('titulo.codigoNivelGrado')" v-model="editedItem.codigo_modular"
                :rules="validationRules.validateCampo" v-if="parametros.cod_modular" />
            </v-col>

            <v-col cols="12" class="py-0">
              <v-row>
                <v-col class="">
                  <label class="black--text">
                    <h3>Seleccionar color</h3>
                  </label>
                </v-col>
              </v-row>

              <v-color-picker v-model="editedItem.color" width="400px"></v-color-picker>
            </v-col>
          </v-row>
        </template>

        <template v-slot:actions>
          <v-spacer></v-spacer>

          <TableButtonComp :disabled="bloquearBotonGurdar" normalButton v-if="evento == 'editar'"
            @click="editNivel(editedItem.id)" text-button="Guardar cambios" iconBut="fas fa-save" />

          <TableButtonComp :disabled="bloquearBotonGurdar" v-if="evento == 'agregar'" @click="addNewNivel()"
            text-button="Guardar" iconBut="fas fa-save" />
        </template>
      </ComunDialogComp>
    </v-form>

    <!-- Modal de visualizaciond e grados -->
    <!-- <ComunDialogComp v-model="dialog2" maxWidth="550" @close-modal="dialog2 = false">
      <template v-slot:title>
        <v-row>
          <v-col cols="12">
            Grados del nivel:
            <v-chip color="blue" class="white--text" label>
              {{ titleVerGrado }}
            </v-chip>
          </v-col>
        </v-row>
      </template>

      <template v-slot:body>
        <div v-if="Grados_nivel.length > 0">
          <v-col cols="12" v-for="item of Grados_nivel" :key="item.id">
            <v-row align="center" class="spacer" no-gutters>
              <v-col cols="1">
                <v-icon color="primary">fa-check</v-icon>
              </v-col>

              <v-col>
                <v-chip color="yellow lighten-4" class="ml-2 black--text" label small>
                  <h3>{{ item.desc_grado }}</h3>
                </v-chip>
              </v-col>

              <v-col cols="6" class="pl-1 text-right">
                <TableButtonComp v-if="componenteEvento.editar_submodulo" editButton tooltipText="Editar grado"
                  @click="editedItemGrado(item)" />
              </v-col>
            </v-row>

            <v-divider></v-divider>
          </v-col>
        </div>

        <v-col cols="12" v-else>
          <v-alert color="#ffbc00" icon="fas fa-exclamation-triangle" dark border="left" prominent elevation="5" dense>
            <span class="font-weight-black">No hay Grados registrados en este Nivel
            </span>
          </v-alert>
        </v-col>
      </template>

      <template v-slot:actions>
        <v-spacer></v-spacer>

        <TableButtonComp normalButton iconBut="fas fa-plus" @click="agregarGrado()"
          v-if="componenteEvento.agregar_submodulo" text-button="Agregar grado" />
   
      </template>
    </ComunDialogComp> -->

    <!--modal agragar grados a nivel-->
    <v-form ref="formDatosGrado" lazy-validation>
      <ComunDialogComp @close-modal="modal_grado = false" v-model="modal_grado" max-width="450" :title="formTitle2">
        <template v-slot:body>
          <v-row dense>
            <v-col cols="12">
              <textfieldComp textLabel="Nivel" v-model="titleVerGrado" disabled />
            </v-col>

            <v-col cols="12">
              <AutocompleteComp textLabel="Grado según Minedu" v-model="newgrado.id_grado_clickone" :items="GradosCk1"
                item-text="desc_grado" item-value="id" :rules="validationRules.validateGrado" :isDisable="bloquearCampo"
                @change="addGradoMinedu(newgrado.id_grado_clickone)" />
            </v-col>

            <v-col cols="12">
              <textfieldComp textLabel="Nombre del grado" v-model="newgrado.desc_grado"
                :rules="validationRules.validateGrado" />
            </v-col>
          </v-row>
        </template>
        <template v-slot:actions>
          <v-spacer></v-spacer>
          <TableButtonComp v-if="evento2 == 'editar'" @click="gradoEdit" iconBut="fas fa-save" normalButton
            text-button="Guardar cambios" />
          <TableButtonComp v-if="evento2 == 'agregar'" @click="importGrado()" iconBut="fas fa-save" normalButton
            text-button="Guardar" />
        </template>
      </ComunDialogComp>
    </v-form>

    <!-- //////////////Modal para confirmar eliminacion /////////////////////    -->

    <ComunDialogComp Deletedialog v-model="dialog_confirm" titleWindow="Eliminar nivel"
      @close-modal="dialog_confirm = false" @delete-item="funcionConfirm('si')" @cancel-item="funcionConfirm('no')">
      <template v-slot:body>
        <div>
          {{ desc_confirm }}
          <v-chip color="primary" dense label>
            {{ name_confirm }}
          </v-chip>
        </div>
      </template>
    </ComunDialogComp>

    <!-- fin de modal de borrar registro -->
  </div>
</template>

<script>
import axios from "../../../../helpers/axios";
import TableButtonComp from "../../../../components/ComponentsEst/TableButtonComp.vue";
import ComunDialogComp from "../../../../components/ComponentsEst/ComunDialogComp.vue";
import AutocompleteComp from "../../../../components/ComponentsEst/AutocompleteComp.vue";
import textfieldComp from "../../../../components/ComponentsEst/textfieldComp.vue";
import { validationRules } from "@/helpers/validatorHelpers.js";
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";

export default {
  name: "nivelesMant",
  components: {
    TableButtonComp,
    ComunDialogComp,
    AutocompleteComp,
    textfieldComp,
  },

  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 35, id_modulo: 5 }, //sud_modulo y modulo

    datoLogin: sessionStorage, // variables de sesion del usuario
    ////////////////////////////////////////////////////////

    //validaciones de formulario

    bloquearBotonGurdar: false,
    // CONSULTA PRINCIPAL
    mostrarMensaje: false,
    NivelesMantenimiento: [],
    parametros: [],

    // modal agregar editar nivel
    evento: "",
    dialog: false,
    editedItem: [],
    NivelesMinedu: [],
    bloquearCampo: false,

    // modal confirmacion
    name_confirm: "",
    id_delete: null,
    dialog_confirm: false,
    desc_confirm: "",
    eventoConfirm: "",

    // modal ver grados
    dialog2: false,
    titleVerGrado: "",
    Grados_nivel: [],
    newgrado: {
      id_nivel: 0,
      desc_grado: "",
      estado: 1,
    },

    // modal agregar editar grado
    evento2: "",
    modal_grado: false,
    bloquearCampoGrado: false,
    GradosCk1: [],
  }),

  computed: {
    validationRules() {
      return validationRules;
    },

    ...mapGetters("login", ["componenteEvento"]),

    formTitle() {
      return this.evento === "agregar" ? "Crear nivel" : "Editar nivel";
    },

    formTitle2() {
      return this.evento2 === "agregar" ? "Crear grado" : "Editar grado";
    },

    ...mapState({
      Grados: (state) => state.nivelesGrados.grados,
    }),

    rules() {
      const rules = [];

      if (this.parametros.cod_modular == true) {
        const rule = (v) => !!v || "Campo requerido";

        rules.push(rule);
      }

      return rules;
    },
  },

  created() {
    this.actualizarParamentro();

    this.getAllParametrosPais(sessionStorage.id_pais);
    this.getNivelesMantenimiento();
    this.$store.dispatch("nivelesGrados/getAllGrados");
    //this.getGradosCk1()
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    closeEdit() {
      // this.limpiarForm();
      this.dialog = false;
      console.log("Se debio haber limpiado");
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    ...mapActions("nivelesGrados", []),

    //////  traer parametros de configuracion segun pais ///////
    async getAllParametrosPais(id) {
      try {
        const response = await axios.get("/sistema/parametroPais/" + id + "");
        this.parametros = response.data;

        if (!this.parametros) {
          this.setEnviarMens({
            tipo: "W",
            mensaje: `No se ha configurado el código modular para el país, contacte al administrador del sistema`,
            tiempo: 10000,
          });
          this.parametros = { cod_modular: false };
        }
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },
    ////////////////////////////////////////////////

    // -- que lista todos los niveles de un colegio indicado. Recibe el Id del colegio a cosultar
    //---------Niveles de mantenimiento -------
    async getNivelesMantenimiento() {
      this.mostrarMensaje = false;
      var id = this.datoLogin.id_colegio;

      try {
        let response = await axios.get("/mantenimiento/nivel/" + id + "");
        this.NivelesMantenimiento = response.data;

        if (this.NivelesMantenimiento.length === 0) {
          this.mostrarMensaje = true;
        }
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },
    /////////////////////////////////////////////////

    /////////  limpiar formulario y reset de campos //////
    limpiarForm() {
      // (this.editedItem.id = 0),
      //   (this.editedItem.nombre = ""),
      //   (this.editedItem.desc_nivel = null),
      //   (this.editedItem.codigo_modular = null),
      //   (this.editedItem.id_usuario = this.datoLogin.id),
      //   (this.editedItem.id_colegio = this.datoLogin.id_colegio),
      //   (this.editedItem.estado = 1),
      this.editedItem = {
        id: 0,
        desc_nivel: "",
        id_usuario: this.datoLogin.id, //18-02-2020. Robert. Se vincula con el usuario en session.
        id_colegio: this.datoLogin.id_colegio,
        color: "#0277BD",
        estado: 1,
        ck1: 0,
        codigo_modular: "",
        id_nivel_clickone: "",
      };

      this.$refs.formDatos.resetValidation();
    },

    ////  funcion de boton agregar //////////
    addItem() {
      this.limpiarForm();

      this.bloquearBotonGurdar = false;
      this.getNivelesPais(sessionStorage.id_pais);
      this.evento = "agregar";
      this.dialog = true;
      this.bloquearCampo = false;
    },

    //************ traer nieveles por pais ******/
    async getNivelesPais(id) {
      try {
        const response = await axios.get("/manager/nivelCkOne/pais/" + id);
        this.NivelesMinedu = response.data;
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },
    //////////////////////////////////////////////////

    ///////// añadir nivel a valor y a campo nombre
    async addNivelMinedu(item) {
      let filtroNivel = this.NivelesMinedu.filter((el) => el.id == item);

      this.editedItem.desc_nivel = filtroNivel[0].desc_nivel;
      this.editedItem.color = filtroNivel[0].color;
    },
    ////////////////////////////////////////////////

    //-- ROBERT.
    //-- ESTE METODO PERMITE CREAR UN NIVEL NUEVO ASOCIADO A UN COLEGIO, EN EL AMBITO DE MANTENIMIENTO
    //----------Crear Nuevo Nivel ---------------
    async addNewNivel() {
      if (this.$refs.formDatos.validate()) {
        let params = this.editedItem;
        this.bloquearBotonGurdar = true;

        try {
          let response = await axios.post("/mantenimiento/nivel/", params);

          if (response.data.messageT == "S") {
            this.dialog = false;
            this.getNivelesMantenimiento();
            this.limpiarForm();
          }
          this.setEnviarMens({
            tipo: response.data.messageT,
            mensaje: `${response.data.message}`,
            tiempo: null,
          });
          this.bloquearBotonGurdar = false;
        } catch (e) {
          this.bloquearBotonGurdar = false;
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        }
      } else {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `Debe de ingresar todos los campos requeridos`,
          tiempo: null,
        });
      }
    },

    //---------obtener datos pàra editar
    editItem(item) {
      this.bloquearBotonGurdar = false;
      this.limpiarForm();
      this.evento = "editar";

      this.getNivelesPais(sessionStorage.id_pais);
      this.dialog = true;
      this.bloquearCampo = true;

      this.editedItem = Object.assign({}, item);

      // console.log("ACACAAA");
      // console.log(this.editedItem.desc_nivel);
    },

    //--------------editar Nivel--------------
    async editNivel(id) {
      let params = this.editedItem;

      if (this.$refs.formDatos.validate()) {
        this.bloquearBotonGurdar = true;
        try {
          let response = await axios.put("/mantenimiento/nivel/" + id, params);

          if (response.data.messageT == "S") {
            this.getNivelesMantenimiento();
            this.dialog = false;
            this.limpiarForm();
          }

          this.setEnviarMens({
            tipo: response.data.messageT,
            mensaje: `${response.data.message}`,
            tiempo: null,
          });
          this.bloquearBotonGurdar = false;
        } catch (e) {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
          this.bloquearBotonGurdar = false;
        }
      } else {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `Debe de ingresar todos los campos requeridos`,
          tiempo: null,
        });
      }
    },

    // activa la modal para confirmar el borrar el registro
    deleteConfirm(item) {
      //console.log(item)
      this.eventoConfirm = "borrar";
      this.dialog_confirm = true;
      this.id_delete = item.id;
      this.name_confirm = `Nivel: ${item.desc_nivel}`;
      this.desc_confirm = "¿Está seguro de eliminar este registro?";
    },

    //------------FUNCION CONFIRMAR -------------
    async funcionConfirm(resp) {
      if (resp == "si" && this.eventoConfirm == "borrar") {
        try {
          let response = await axios.delete(
            "/mantenimiento/nivel/" + this.id_delete
          );
          this.dialog_confirm = false;

          if (response.data.messageT == "S") {
            this.getNivelesMantenimiento();
          }

          this.setEnviarMens({
            tipo: response.data.messageT,
            mensaje: `${response.data.message}`,
            tiempo: null,
          });
        } catch (e) {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        }
      } else if (resp == "no" && this.eventoConfirm == "borrar") {
        this.dialog_confirm = false;
      } else if (resp == "si" && this.eventoConfirm == "agregarOtroGrado") {
        this.dialog_confirm = false;
        this.getGradosCk1();
        this.newgrado.desc_grado = "";
      } else {
        this.dialog_confirm = false;
        this.modal_grado = false;
      }
    },

    ////////////////////////////////////////////////////////
    //-- METODO QUE LISTA TODOS LOS GRADOS ASOCIADOS A UN NIVEL DE UN COLEGIO, RECIBE EL ID_NIVEL
    //-------------------------------------
    async getAllGradosNivel(item) {
      //console.log(item)
      this.newgrado.id_nivel = item.id;
      this.newgrado.id_nivel_clickone = item.id_nivel_clickone;
      this.titleVerGrado = item.desc_nivel;
      //console.log(item)

      try {
        let response = await axios.get(
          "/mantenimiento/grado/grados/" + item.id + ""
        );
        this.Grados_nivel = response.data;
        this.dialog2 = true;
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },

    ///////////////////Limpiar formulario grados////////////////////
    async limpiarFormGrados() {
      this.newgrado.desc_nivel = this.titleVerGrado;
      this.newgrado.id_grado_clickone = "";
      this.newgrado.desc_grado = "";
      (this.newgrado.id_us_ing = this.datoLogin.id), //18-02-2020. Robert. Se vincula con el usuario en session.
        (this.newgrado.id_colegio = this.datoLogin.id_colegio);
      this.newgrado.id = "";

      this.$refs.formDatosGrado.resetValidation();
    },

    // modal agregar grado
    agregarGrado() {
      this.limpiarFormGrados();
      this.evento2 = "agregar";
      this.bloquearCampoGrado = false;

      this.getGradosCk1();
      this.modal_grado = true;
    },

    //********** metodo para traer los niveles de ck1 */
    async getGradosCk1() {
      let params = {
        cid: sessionStorage.id_colegio,
        id_pais: sessionStorage.id_pais,
        id_nivel: this.newgrado.id_nivel_clickone,
      };

      try {
        let response = await axios.post(
          "/mantenimiento/grado/mgn/list/",
          params
        );
        this.GradosCk1 = response.data;
        //console.log(this.GradosCk1)

        if (response.data.length === 0) {
          this.setEnviarMens({
            tipo: "W",
            mensaje:
              "El nivel seleccionado ya tiene todos los grados asignados",
            tiempo: null,
          });
        }
        //console.log(this.GradosCk1)
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },

    ///////// añadir grado valor y a campo nombre
    addGradoMinedu(item) {
      let filtroGrado = this.GradosCk1.filter((el) => el.id == item);

      this.newgrado.desc_grado = filtroGrado[0].desc_grado;
      /* this.newgrado.desc_grado = item.desc_grado
            this.newgrado.id_grado_clickone = item.id */
    },

    //---------Importar Grado ---------------
    async importGrado() {
      let params = this.newgrado;
      this.newgrado.id = this.newgrado.id_nivel;
      //console.log(this.newgrado)

      if (this.$refs.formDatosGrado.validate()) {
        try {
          let response = await axios.post(
            "/mantenimiento/grado/import/",
            params
          );

          if (response.data.messageT == "S") {
            this.getAllGradosNivel(this.newgrado);
            this.getGradosMantenimiento();

            this.agregarOtroGrado();
          }

          this.setEnviarMens({
            tipo: response.data.messageT,
            mensaje: response.data.message,
            tiempo: null,
          });
        } catch (e) {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        }
      } else {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `Debe de ingresar todos los campos requeridos`,
          tiempo: null,
        });
      }
    },

    agregarOtroGrado() {
      this.eventoConfirm = "agregarOtroGrado";
      this.dialog_confirm = true;

      //this.name_confirm = `Nivel: ${item.desc_nivel}`
      this.desc_confirm = "¿Desea agregar otro grado al nivel?";
    },

    //********  funcion por props para comunicacion de actualizacion de grado ****/
    getGradosMantenimiento() {
      this.$emit("getAllGradosMantenimiento");
    },

    editedItemGrado(item) {
      this.limpiarFormGrados();
      this.evento2 = "editar";
      this.getGradosCk1Niveledit(item.id_grado_clickone);

      this.modal_grado = true;
      this.bloquearCampoGrado = true;

      this.newgrado.id_grado_clickone = item.id_grado_clickone;
      this.newgrado.desc_grado = item.desc_grado;
      this.newgrado.id = item.id;

      //console.log(item)
    },

    async getGradosCk1Niveledit(id) {
      try {
        let response = await axios.get("/manager/gradoCkOne/" + id + "");
        this.GradosCk1 = response.data;
        //console.log(this.GradosCk1)
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },

    //-- 02-03-2020. Ing. Robert. Metodo que permite actualizar un grado en Niveles.
    async gradoEdit() {
      if (this.$refs.formDatosGrado.validate()) {
        let niv = this.newgrado.id_nivel;
        let params = this.newgrado;
        //console.log(this.newgrado)

        try {
          let response = await axios.put(
            "/mantenimiento/grado/" + params.id,
            params
          );

          if (response.data.messageT == "S") {
            this.newgrado.id = niv;

            this.getAllGradosNivel(this.newgrado);
            this.getGradosMantenimiento();
            this.$store.dispatch("nivelesGrados/getAllGrados");

            this.modal_grado = false;
          }

          this.setEnviarMens({
            tipo: response.data.messageT,
            mensaje: response.data.message,
            tiempo: null,
          });
        } catch (e) {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        }
      } else {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `Debe de ingresar todos los campos requeridos`,
          tiempo: null,
        });
      }
    },
  },
};
</script>
